
import { defineComponent } from 'vue'
import { iFixedValue } from '../../../LovsManagement'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Message from 'primevue/message'
import lovsManagementFixedLovsTableDescriptor from './LovsManagementFixedLovsTableDescriptor.json'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'lovs-management-fixed-lovs-table',
    components: { Column, DataTable, Message, Textarea },
    props: {
        listForFixLov: {
            type: Array
        }
    },
    emits: ['touched', 'sorted'],
    data() {
        return {
            lovsManagementFixedLovsTableDescriptor,
            selectedValue: {} as iFixedValue,
            values: [] as iFixedValue[],
            filters: { global: [filterDefault] } as Object
        }
    },
    computed: {
        listIsInvalid() {
            for (let i = 0; i < this.values.length; i++) {
                const fixedLovListItem = this.values[i] as { VALUE: string; DESCRIPTION: string }
                if (fixedLovListItem.VALUE?.trim() && fixedLovListItem.DESCRIPTION?.trim()) {
                    return false
                }
            }
            return true
        }
    },
    created() {
        this.load()
    },
    methods: {
        load() {
            this.values = this.listForFixLov as any[]
        },
        addFixedValue() {
            this.values.push({ VALUE: '', DESCRIPTION: '' })
        },
        setPositionOnReorder(event) {
            this.values = event.value
            this.$emit('sorted', this.values)
        },
        deleteValueConfirm(index: number) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.deleteValue(index)
                }
            })
        },
        deleteValue(index: number) {
            this.values.splice(index, 1)
        },
        onCellEditComplete(event: any) {
            this.values[event.index] = event.newData
        }
    }
})
